import React from 'react';
import { GlobalDesignActionLobbyItem } from '../types';
import { useGroupsPreview } from '../common/lobby/useGroupsPreview';
import { useGroupComponentProps } from '../common/lobby/useGroupComponentProps';
import { CornerStyleValueService } from './cornersStyleValueService';

const DEFAULT_VALUES = {
  borderRadius: null,
  isMixed: false,
};

const CornerLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const GroupPreviewComponent = useGroupsPreview('borderRadius', props.group);
  const groupComponentProps = useGroupComponentProps<
    typeof DEFAULT_VALUES,
    'Corners'
  >(props.group, DEFAULT_VALUES, (acc, styleValue) => {
    if (acc.isMixed) {
      return acc;
    }

    const valueService = new CornerStyleValueService();
    const normalizedValue = valueService.normalize(styleValue);

    if (acc.borderRadius && acc.borderRadius !== normalizedValue) {
      acc.borderRadius = '';
      acc.isMixed = true;
    } else {
      acc.borderRadius = normalizedValue;
    }

    return acc;
  });

  if (!GroupPreviewComponent) {
    return null;
  }

  return (
    <GroupPreviewComponent
      value={{
        borderRadius: {
          value: groupComponentProps.borderRadius || props.group.displayName,
          unit: '',
        },
        isMixed: groupComponentProps.isMixed,
      }}
      onClick={props.onSelect}
    />
  );
};

export default CornerLobbyItem;
